import React from 'react';

export const Button = React.forwardRef(({ className = '', variant = 'default', size = 'default', asChild = false, children, ...props }, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50';

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      className: `${children.props.className || ''} ${className}`.trim(),
      ref,
      ...props
    });
  }

  return (
    <button ref={ref} className={`${baseStyles} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';
